import { createSelector } from 'reselect';

export default createSelector(
    (state, hash) => state.current_event.ticketTypes[hash],
    ticketType => ticketType || null,
);
